import { useEffect } from 'react';

interface BandsInTownWidgetProps {
    className?: string;
}

export function BandsInTownWidget({ className = '' }: BandsInTownWidgetProps) {
    useEffect(() => {
        // Load the Bandsintown widget script
        const script = document.createElement('script');
        script.src = 'https://widgetv3.bandsintown.com/main.min.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script);
            }
        };
    }, []);

    return (
        <div className={`bg-card border border-border rounded-lg overflow-hidden ${className}`}>
            <a
                className="bit-widget-initializer block"
                data-artist-name="id_15519244"
                data-background-color="rgba(42,42,42,1)"
                data-separator-color="rgba(80,80,80,1)"
                data-text-color="rgba(255,255,255,1)"
                data-font="Montserrat"
                data-auto-style="true"
                data-button-label-capitalization="capitalize"
                data-location-capitalization="capitalize"
                data-venue-capitalization="capitalize"
                data-display-local-dates="true"
                data-local-dates-position="tab"
                data-display-past-dates="false"
                data-display-details="false"
                data-display-lineup="true"
                data-display-start-time="true"
                data-social-share-icon="false"
                data-display-limit="all"
                data-date-format="MMM. D, YYYY"
                data-date-orientation="horizontal"
                data-date-border-color="#3A3A3A"
                data-date-border-width="1px"
                data-date-border-radius="8px"
                data-event-ticket-cta-size="medium"
                data-event-ticket-text="GET TICKETS"
                data-event-ticket-cta-text-color="rgba(30,30,30,1)"
                data-event-ticket-cta-bg-color="rgba(255,213,170,1)"
                data-event-ticket-cta-border-radius="4px"
                data-sold-out-button-text-color="#FFFFFF"
                data-sold-out-button-background-color="#3A3A3A"
                data-sold-out-button-clickable="true"
                data-event-rsvp-position="hidden"
                data-follow-section-position="top"
                data-follow-section-alignment="center"
                data-follow-section-header-text="Get updates on new shows"
                data-follow-section-cta-text="FOLLOW on BandsInTown"
                data-follow-section-cta-text-color="rgba(30,30,30,1)"
                data-follow-section-cta-bg-color="rgba(255,213,170,1)"
                data-follow-section-cta-border-radius="4px"
                data-play-my-city-position="bottom"
                data-play-my-city-alignment="center"
                data-play-my-city-header-text="Don't see a show near you?"
                data-play-my-city-cta-text="REQUEST A SHOW"
                data-play-my-city-cta-text-color="rgba(30,30,30,1)"
                data-play-my-city-cta-bg-color="rgba(255,213,170,1)"
                data-play-my-city-cta-border-radius="4px"
                data-language="en"
                data-bit-logo-position="bottomRight"
                data-bit-logo-color="rgba(255,213,170,1)"
            ></a>
        </div>
    );
}
